import { colors } from "lib/colors"
import styled from "styled-components"
import { BOARD_STYLED_PROPS, POINT_STYLED_PROPS } from "./interfaces"

export const BoardWrapper = styled.section<BOARD_STYLED_PROPS>`
  position: relative;
  width: 100%;
  height: 85%;
`
export const GameBoardWrapper = styled.div<BOARD_STYLED_PROPS>`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 511px;
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  opacity: ${({ isGameActive }) => (isGameActive ? "1" : "0")};
  transition: ${({ isGameActive }) =>
    isGameActive ? "opacity 0.2s linear 0.1s" : "opacity 0.2s linear"}; ;
`
export const StakeWrapper = styled.div<BOARD_STYLED_PROPS>`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: ${({ isGameActive }) => (isGameActive ? "-1" : "1")};
  opacity: ${({ isGameActive }) => (isGameActive ? "0" : "1")};
  transform: ${({ isGameActive }) => (isGameActive ? "translateY(-20px)" : "")};
  transition: transform 0.4s cubic-bezier(0.42, 0, 0.09, 1),
    opacity 0.4s cubic-bezier(0.42, 0, 0.09, 1);
  margin-top: 80px;
`

export const CredentialsWrapper = styled.div<BOARD_STYLED_PROPS>`
  opacity: ${({ isGameActive }) => (isGameActive ? "1" : "0")};
  transition: ${({ isGameActive }) =>
    isGameActive ? "transform 0.4s cubic-bezier(0.57, 0, 0.04, 1)" : ""};
  &.banker {
    transform: ${({ isGameActive }) =>
      isGameActive ? "translateX(0)" : "translateX(100%)"};
  }
  &.tie,
  &.player {
    transform: ${({ isGameActive }) =>
      isGameActive ? "translateX(0)" : "translateX(-100%)"};
  }
`

export const NameWrapper = styled.div`
  display: flex;
  margin-bottom: 5px;
  overflow: hidden;
`
export const PointsWrapper = styled.div`
  position: relative;
  margin-left: 5px;
  height: 17px;
`
export const Points = styled.div<POINT_STYLED_PROPS>`
  position: absolute;
  bottom: 0px;
  display: flex;
  flex-direction: column-reverse;
  animation: ${({ animateNow, animName }) =>
    animateNow && `anim${animName} ${animName / 10}s forwards`};
  @keyframes anim4 {
    0% {
      transform: translateY(0px);
    }

    100% {
      transform: translateY(17px);
    }
  }

  @keyframes anim18 {
    0% {
      transform: translateY(0px);
    }
    20% {
      transform: translateY(17px);
    }
    80% {
      transform: translateY(17px);
    }
    100% {
      transform: translateY(34px);
    }
  }

  @keyframes anim22 {
    0% {
      transform: translateY(0px);
    }
    20% {
      transform: translateY(17px);
    }
    80% {
      transform: translateY(17px);
    }
    100% {
      transform: translateY(34px);
    }
  }
`
export const Point = styled.div`
  font-size: 16px;
  height: 17px;
  width: 15px;
  color: ${colors.secondary};
`
export const Title = styled.div`
  font-size: 16px;
  color: ${colors.quaternary};
  text-transform: uppercase;
`

export const SubTitle = styled.div`
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  color: ${colors.quaternary};
  margin-bottom: 19px;
  background: ${colors.primaryDark};
  border-radius: 10px;
  padding: 0 8px;
  height: 18px;
  max-width: 128px;
  overflow: hidden;
  span {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &.active {
    color: ${colors.secondary};
    svg {
      path {
        fill: ${colors.secondary};
      }
    }
  }
  .currency {
    display: flex;
    align-items: center;
  }
`
export const UpperContent = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
`
export const CardStackWrapper = styled.div`
  position: relative;
  height: 135px;
`
